export default __webpack_public_path__ + "static/media/London Fog - proportioned_170.0521bcb3.jpg";